import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { UserState } from '@core/state/user.state';
import { DecoratorInjectModule } from '@core/app/decorator-inject.module';
import { PrivilegesUsers } from '@core/privileges/privileges-users';
import { map } from 'rxjs/operators';

export function OnlyViewMode(modules: PrivilegesModules[], privilege?: PrivilegesUsers) {
    return function (target: any, key: string) {
        Object.defineProperty(target, key, {
            get: function () {
                const userState: UserState = DecoratorInjectModule.injector?.get(UserState);

                return userState
                    ?.checkPrivilege(privilege ? privilege : PrivilegesUsers.Edit, modules[0])
                    .pipe(map((isEdit: boolean) => !isEdit));
            },
            enumerable: true,
            configurable: true,
        });
    };
}
